import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDRbKFUigg6Q-t40V1PlsFSdTqQabR5qpA",
  authDomain: "crosswatch-38b05.firebaseapp.com",
  projectId: "crosswatch-38b05",
  storageBucket: "crosswatch-38b05.firebasestorage.app",
  messagingSenderId: "471291442940",
  appId: "1:471291442940:web:a81b358635bf237ddd0979",
  measurementId: "G-8J0VFBLYYE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);

// Analytics (only in browser)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;
